module.exports = __webpack_public_path__ + "static/3-d003c60671ded1df977f0c90734f5ab3.mp4";